import React, { useState, useEffect, useRef } from "react"
import useInterval from "@use-it/interval"
import Swiper from "react-id-swiper"
import { useSelector } from "react-redux"

import * as s from "./HomeHero.module.scss"

import Arrow from "@assets/icons/arrow.inline.svg"

import { Slide } from "./Slide"

export const HomeHero = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(null)
  /*eslint-disable*/
  const [timer, setTimer] = useState(5000)
  /*eslint-enable*/
  const [paused, setPaused] = useState(true)
  const [swiper, setSwiper] = useState(null)
  const hasPassedAgeGate = useSelector(state => state.agegate.havePassed)

  const _dotsContainer = useRef(null)

  const swiperParams = {
    spaceBetween: 0,
    renderPagination: true,
    autoplay: {
      delay: timer,
    },
  }

  useEffect(() => {
    if (paused) return
    if (swiper !== null && _dotsContainer.current.offsetParent) {
      swiper.on("slideChange", () => setCurrentSlide(swiper.realIndex))
    }
  }, [swiper])

  useEffect(() => {
    setCurrentSlide(0)
  }, [])

  useEffect(() => {
    if (!hasPassedAgeGate) {
      /*eslint-disable*/
      setPaused(old => {
        return true
      })
    } else {
      setPaused(old => {
        return false
      })
      /*eslint-enable*/
    }
  }, [hasPassedAgeGate])

  const nextSlide = () => {
    if (paused) return
    if (currentSlide < data.length - 1) {
      setCurrentSlide(currentSlide => currentSlide + 1)
    } else {
      setCurrentSlide(0)
    }
  }

  useInterval(() => {
    if (_dotsContainer.current.offsetParent) return
    nextSlide()
  }, timer)

  return (
    <div className={s.homeHeroWrapper}>
      <div className={s.homeHeroWrapper__inner}>
        <div className={s.carouselSwiper}>
          <Swiper {...swiperParams} getSwiper={setSwiper}>
            {data.map((slide, i) => {
              return (
                <div key={i}>
                  <Slide data={slide} active={true} />
                </div>
              )
            })}
          </Swiper>
        </div>

        <div className={s.carousel}>
          {data.map((slide, i) => {
            return (
              <div key={i}>
                <Slide data={slide} i={i} active={i === currentSlide} />
              </div>
            )
          })}
        </div>

        <div className={s.dots} ref={_dotsContainer}>
          {data.map((slide, i) => {
            return (
              <div
                key={i}
                className={`${s.dots__dot} ${
                  i == currentSlide && s.dots__dot___active
                }`}
              />
            )
          })}
        </div>

        <div
          className={s.breadcrumbs}
          onMouseEnter={() => {
            if (paused) return
            else setPaused(true)
          }}
          onMouseLeave={() => {
            if (paused) return
            else setPaused(false)
          }}
        >
          {data.map((slide, i) => {
            return (
              <div
                key={i}
                className={`${s.breadcrumbs__breadcrumb} ${
                  currentSlide === i && s.breadcrumbs__breadcrumb___active
                }  ${
                  timer == null &&
                  currentSlide === i &&
                  s.breadcrumbs__breadcrumb___forceActive
                }`}
                onClick={() => {
                  setCurrentSlide(i)
                  setPaused(true)
                }}
              >
                <h4>{slide.title}</h4>
                <p>{slide.blurb}</p>

                <div className={s.breadcrumbs__breadcrumbHover}>
                  <div className={s.breadcrumbs__breadcrumbHover__pullUp}>
                    <Arrow />
                  </div>
                  <h4>{slide.title}</h4>
                  <p>{slide.blurb}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
